import React from 'react';
import { FollowUpCommentText } from './styles';

const processComment = (comment: string) => {
  const [firstLine, ...rest] = comment.split('\n');
  return { firstLine, rest: rest.join('\n') };
};

interface ICommentComponentProps {
  comment: string;
}

const CommentComponent = ({ comment }: ICommentComponentProps) => {
  const { firstLine, rest } = processComment(comment);

  return (
    <FollowUpCommentText>
      {firstLine === "Mudança de responsáveis" ? (
        <span>
          <strong>{firstLine}</strong>
          {rest && `\n${rest}`}
        </span>
      ) : (
        comment
      )}
    </FollowUpCommentText>
  );
};

export default CommentComponent;
